var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 8.70666L15.9723 9.82443L15.4134 9.26554L12.06 12.6189L11.5011 15.4133L10.3833 16.5311L7.03 13.1778L3.11778 17.09L2 15.9722L5.91223 12.06L2.55889 8.70666L3.67667 7.5889L6.47112 7.03001L9.82446 3.67667L9.26557 3.11778L10.3833 2L17.09 8.70666Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.570d7aa3e034d36431b8a6c7aed9d951.svg";
export { ForwardRef as ReactComponent };